export default "__VITE_ASSET__398a408e__"